import * as React from 'react';
import { ChevronDownRegular } from '@fluentui/react-icons';
import { slot } from '@fluentui/react-utilities';
import { useButton_unstable } from '../Button/index';
/**
 * Given user props, returns the final state for a MenuButton.
 */ export const useMenuButton_unstable = ({ menuIcon, ...props }, ref)=>{
    const buttonState = useButton_unstable(props, ref);
    var _props_ariaexpanded;
    buttonState.root['aria-expanded'] = (_props_ariaexpanded = props['aria-expanded']) !== null && _props_ariaexpanded !== void 0 ? _props_ariaexpanded : false;
    return {
        // Button state
        ...buttonState,
        // State calculated from a set of props
        iconOnly: Boolean(!props.children),
        // Slots definition
        components: {
            root: 'button',
            icon: 'span',
            menuIcon: 'span'
        },
        menuIcon: slot.optional(menuIcon, {
            defaultProps: {
                children: /*#__PURE__*/ React.createElement(ChevronDownRegular, null)
            },
            renderByDefault: true,
            elementType: 'span'
        })
    };
};
